import { PATH_DASHBOARD } from '@/routes/paths';

/**
 * Avisos do painel do produtor, na ordem em que aparecem no modal. Formato em
 * `@/components/announcements/announcementShape`. Dê `expiresAt` a todo aviso: sem ele, o aviso só
 * sai do ar com outro deploy.
 */
export const DASHBOARD_ANNOUNCEMENTS = [
  {
    id: 'analytics-pro-lancamento:v1',
    badge: 'Novo · incluso na sua conta',
    title: 'Cakto Analytics Pro: o lucro real das suas campanhas',
    description:
      'O que as ferramentas de trackeamento cobram todo mês agora vem dentro da Cakto, sem pagar nada a mais. Faturamento líquido, gasto com anúncios, ROAS, ROI e lucro de todos os seus produtos num painel só.',
    image: {
      src: '/assets/images/announcements/analytics-pro-dashboard.webp',
      alt: 'Resumo do Analytics Pro com faturamento líquido, gastos com anúncios, ROAS, lucro, ROI e margem de lucro',
    },
    seeNow: PATH_DASHBOARD.general.analytics,
    expiresAt: '2026-11-30',
  },
  {
    id: 'analytics-pro-campanhas:v1',
    badge: 'Novo',
    title: 'ROAS e CPA de cada campanha, conjunto e anúncio',
    description:
      'Descubra qual anúncio dá lucro e qual só gasta, sem abrir o Gerenciador. As vendas vêm da própria Cakto: Pix pago depois, reembolso e chargeback entram certos.',
    image: {
      src: '/assets/images/announcements/analytics-pro-campanhas.webp',
      alt: 'Tabela de campanhas com acessos, vendas, faturamento, gasto, ROAS e CPA de cada campanha',
    },
    seeNow: PATH_DASHBOARD.general.analytics,
    expiresAt: '2026-11-30',
  },
  {
    id: 'analytics-pro-conectar-meta:v1',
    badge: 'Grátis',
    title: 'É só conectar a sua conta do Meta',
    description:
      'No Analytics Pro, clique em Conectar Meta Ads e autorize. O gasto dos anúncios entra sozinho, de hora em hora. A Cakto só lê os números: nada muda nos seus anúncios.',
    image: {
      src: '/assets/images/announcements/analytics-pro-conectar.webp',
      alt: 'Cartão Custo dos anúncios do Meta com o botão Conectar Meta Ads',
    },
    seeNow: PATH_DASHBOARD.general.analytics,
    expiresAt: '2026-11-30',
  },
  {
    id: 'members-v3-protecao-de-conteudo:v1',
    badge: 'Novo',
    title: 'Proteja o seu conteúdo contra cópia',
    description:
      "Nas configurações da sua área na Cakto Members V3, ligue a marca d'água com o e-mail, o nome ou o CPF do aluno nos vídeos e nos ebooks, e bloqueie a cópia e a impressão do conteúdo. O PDF baixado também sai marcado.",
    image: {
      src: '/assets/images/announcements/members-v3-protecao-de-conteudo.webp',
      alt: "Configurações da área de membros com a marca d'água em vídeos e ebooks e o bloqueio de captura de tela ligados",
    },
    expiresAt: '2026-12-03',
  },
  {
    id: 'members-v3-ebooks:v1',
    badge: 'Novo',
    title: 'Ebooks dentro da sua área de membros',
    description:
      'Crie uma seção de ebooks no construtor da Cakto Members V3 e suba o PDF. O aluno lê página a página na própria área, destaca trechos e faz anotações. Você também pode vender o ebook como upsell.',
    image: {
      src: '/assets/images/announcements/members-v3-ebooks.webp',
      alt: 'Fileira de ebooks na área do aluno e o leitor página a página',
    },
    expiresAt: '2026-12-03',
  },
];
